import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import keyBy from 'lodash-es/keyBy';
import omit from 'lodash-es/omit';
import { IUnallocatedProduct } from './unallocatedProductsInterfaces';

interface IUnallocatedProductsState {
  lines: Record<string, IUnallocatedProduct>;
  loading: boolean;
  isLoaded: boolean;
}

const initialState: IUnallocatedProductsState = {
  isLoaded: false,
  lines: {},
  loading: false
};

// tslint:disable: no-empty
const unallocatedProductsSlice = createSlice({
  initialState,
  name: 'unallocatedProducts',
  reducers: {
    fetch: {
      prepare: (payload: { partialUpdateId?: string; full?: boolean }) => ({
        payload: { partialUpdateId: payload.partialUpdateId ?? '', full: payload.full ?? false }
      }),
      reducer: (state, action: PayloadAction<{ partialUpdateId: string; full: boolean }>) => {}
    },
    remove: (state, action: PayloadAction<string[]>) => {
      state.lines = omit(state.lines, action.payload);
    },
    set: (state, action: PayloadAction<IUnallocatedProduct[]>) => {
      state.lines = { ...state.lines, ...keyBy(action.payload, x => x.inventTransId) };
    },
    setLoaded: state => {
      state.isLoaded = true;
    },
    toggleLoading: state => {
      state.loading = !state.loading;
    }
  }
});

export const {
  actions: unallocatedProductsActionCreators,
  reducer: unallocatedProductsReducer
} = unallocatedProductsSlice;
